import { Message, util, Properties, configure } from "protobufjs/light";
import Long from 'long'
import { ok, err } from '@xlearn/common'
import { SerializerError, DeserializerError } from '../api'

// needed to configure long, because it couldn't found it at deserialization
util.Long = Long;
configure();

export class ProtobufSerializer {

  static serialize<TMessage extends Message<Object>>(payload: Properties<TMessage>, MessageClass: typeof Message) {

    const verifyError = MessageClass.verify(payload)
    if (verifyError) {
      return err({
        code: 'invalid-input',
        details: verifyError
      } as SerializerError)
    }

    const message = new MessageClass(payload)
    const buffer = MessageClass.encode(message).finish()
    return ok(buffer)
  }

  static deserialize<TMessage extends Message<Object>>(content: Uint8Array, MessageClass: typeof Message) {

    let decoded: TMessage
    try {
      decoded = MessageClass.decode(content) as TMessage
    }
    catch (error) {
      if (error instanceof util.ProtocolError) {
        return err({
          code: 'schema-error',
          details: error
        } as DeserializerError)
      }

      return err({
        code: 'wire-error',
        details: error
      } as DeserializerError)
    }

    return ok(decoded as TMessage)
  }

  static serializeDate(date: Date) {
    const timestamp = Math.floor(date.getTime() / 1000)
    return Long.fromNumber(timestamp)
  }

  static deserializeDate(timestamp: number | Long) {

    let num
    if (Long.isLong(timestamp)) {
      num = timestamp.toNumber()
    } else {
      num = timestamp
    }

    return new Date(num * 1000)
  }
}
